import { useLayoutEffect } from 'react';

import { MessagingContext, MessagingProvider } from '@sorare/wallet-shared';

import { ErrorFeedback } from './components/ErrorBoundary/ErrorFeedback.tsx';
import Main from './components/Main.tsx';
import { ALLOWED_ORIGIN } from './config.ts';
import { FormsProvider } from './contexts/forms/index.tsx';
import { InfoProvider } from './contexts/info.tsx';
import { PromptProvider } from './contexts/prompt.tsx';
import { WalletProvider } from './contexts/wallet/index.tsx';

import './styles.css';

const useMeasureScrollbars = () => {
  useLayoutEffect(() => {
    const hider = document.createElement('div');
    hider.className = 'sr-only';

    const measure = document.createElement('div');
    measure.style.width = '40px';
    measure.style.overflowY = 'scroll';

    hider.appendChild(measure);
    document.body.appendChild(hider);

    const cb = () => {
      const scrollbarWidth = measure.offsetWidth - measure.clientWidth;

      document.documentElement.style.setProperty(
        '--scrollbar-width',
        `${scrollbarWidth}px`
      );

      document.documentElement.dataset.overflowScrollbars = scrollbarWidth
        ? 'false'
        : 'true';
    };
    cb();
    const obs = new ResizeObserver(entries => {
      entries.forEach(() => {
        cb();
      });
    });
    obs.observe(measure);

    return () => {
      obs.disconnect();
      document.body.removeChild(hider);
    };
  }, []);
};

const App = () => {
  useMeasureScrollbars();

  if (!ALLOWED_ORIGIN) return null;

  return (
    <MessagingProvider
      Context={MessagingContext}
      allowedOrigins={[ALLOWED_ORIGIN]}
      target={{ window: window.parent, origin: ALLOWED_ORIGIN }}
    >
      <ErrorFeedback>
        <InfoProvider>
          <PromptProvider>
            <WalletProvider>
              <FormsProvider>
                <Main />
              </FormsProvider>
            </WalletProvider>
          </PromptProvider>
        </InfoProvider>
      </ErrorFeedback>
    </MessagingProvider>
  );
};

export default App;
